import React from "react"
import classnames from "classnames"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import { Link } from "gatsby"
import FacebookIcon from "../assets/icons/logo-facebook.svg"
import InstagramIcon from "../assets/icons/logo-instagram.svg"

function SocialLink({ url, label, icon: Icon, className }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      className={classnames(
        "w-8 h-8 hover:text-primary hover:bg-white focus:text-primary focus:bg-white focus:outline-none transition-colors duration-150 ease-out",
        className
      )}
    >
      <span className="sr-only">{label}</span>
      <Icon aria-hidden={true} />
    </a>
  )
}

export default function Footer() {
  const {
    title,
    contactDetails: { facebook, instagram },
  } = useSiteMetadata()

  return (
    <div className="bg-primary text-white">
      <div className="container container-centered flex flex-col md:flex-row items-start md:items-center justify-between py-6.25">
        <Link className="mb-6 md:mb-0" to="/">
          <img alt={title} src={require("../assets/images/logo-white.png")} />
        </Link>
        <div className="inline-flex items-center">
          <SocialLink
            className="mr-8 rounded-full"
            label="Facebook"
            url={facebook}
            icon={FacebookIcon}
          />
          <SocialLink
            className="rounded-xl"
            label="Instagram"
            url={instagram}
            icon={InstagramIcon}
          />
        </div>
      </div>
      <div className="bg-black bg-opacity-50 py-2">
        <div className="container container-centered">
          <p className="text-body-14">
            Copyright, &copy;2020. All rights reserved. SuperLife is a trademark
            of SuperLife.
          </p>
        </div>
      </div>
    </div>
  )
}
